module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('checklist', {
    attrs: {
      "title": (_vm.index + 1) + '、' + _vm.cloums.subjectName,
      "options": _vm.options,
      "max": _vm.cloums.type == 1 ? 1 : _vm.cloums.choices.options.length
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21dbbbf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/questionnaireTempelet/chooseTempelet.vue
// module id = ZdJk
// module chunks = 6